import * as React from 'react';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';

import { TextLogoSvg } from './assets/TextLogoSvg';
import { IconLogoSvg } from './assets/IconLogoSvg';

export const Logo = () => (
  <Link to="/swap">
    <Box
      sx={{
        display: { xs: 'none', md: 'flex' },
      }}
    >
      <TextLogoSvg />
    </Box>
    <Box
      sx={{
        display: { xs: 'flex', md: 'none' },
      }}
    >
      <IconLogoSvg />
    </Box>
  </Link>
);
